import { Button, Col, Form, Input, Row, Space, theme } from "antd";
import { useGetTasksQuery } from "../../../api/plamo-api";
import { useCallback, useEffect, useMemo, useState } from "react";
import PlamoApiWithSaveNotifications from "../util/with-save-notification";
import { CheckOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { IconAngleDownSolidFull, IconAngleUpSolidFull, IconBanSolid, IconCircleRegularFull } from "../../../icon";
import { useGetUsersLightQuery } from "../../../api/auth-api";
import dayjs from "dayjs";
import FormItem from "../form/form-item";
import FormItemDate from "../form/form-items/form-item-date";
import FormItemUser from "../form/form-items/form-item-user";
import { Link } from "react-router-dom";
import FormItemEnum from "../form/form-items/form-item-enum";

const { 
  useCreateTaskWithSaveNotificationMutation, 
  useUpdateTaskWithSaveNotificationMutation,
  useDeleteTaskWithSaveNotificationMutation 
} = PlamoApiWithSaveNotifications;

const PriorityIcon = ({ priority }) => {
  if(priority === 1) {
    return <IconAngleDownSolidFull />;
  }
  if(priority === 3) {
    return <IconCircleRegularFull />;
  }
  if(priority === 5) {
    return <IconAngleUpSolidFull />;
  }
  return <></>;
}

export const TaskUsernameDate = ({ task }) => {
  const { data: users } = useGetUsersLightQuery({}) as any;
  const usernameDisplayAssigned = useMemo(() => users?.filter(u => u.id === task.assignedUserId).map(u => u.usernameDisplay)[0] || "Unbekannt", [users, task.assignedUserId])
  const usernameDisplayLastEdit = useMemo(() => users?.find(u => u.id === task.updateUserId)?.usernameDisplay || "Unbekannt", [users, task.updateUserId])
  const dateDisplayLastEdit = useMemo(() => dayjs(task.updateTime).format('DD.MM.YYYY HH:mm:ss'), [task.updateTime])
  //const dateDisplay = useMemo(() => dayjs(task.creationTime).format('DD.MM.YYYY HH:mm:ss'), [task.creationTime])
  //const modifiedDisplay = useMemo(() => task.creationTime !== task.updateTime ? ' (bearbeitet)' : '', [task.creationTime, task.updateTime])
  const dateDisplayDue = useMemo(() => dayjs(task.timestamp).format('DD.MM.YYYY'), [task.timestamp])

  return <>
    { !task.solved && <><PriorityIcon priority={task.priority} /> Zugewiesen an <strong>{ usernameDisplayAssigned }</strong>, fällig am <strong>{ dateDisplayDue }</strong></> }
    { task.solved && <><PriorityIcon priority={task.priority} /> Erledigt von <strong>{ usernameDisplayLastEdit }</strong> am <strong>{ dateDisplayLastEdit }</strong></> }
  </>
}

const TaskDescriptionLine = ({ line, task }) => {
  const linkPlaceholders = line.match(/\[(.*?)\]/);
  let result
  if(task.link && linkPlaceholders) {
    const parts = line.split(linkPlaceholders[0])
    result = <>{ parts[0] || '' }<Link to={task.link}>{ linkPlaceholders[1] }</Link>{ parts[1] || '' }</>
  } else {
    result = <>{ line }</>
  }
  return result
}

const TaskDescription = ({ task }) => {
  return task.text?.split('\n').map(l => <><TaskDescriptionLine line={l} task={task} /><br/></>)
}

function TaskField({ value, onChange, edit, onEdit, onFinishEdit, onCancelEdit, onDelete }: any) {
  const [editContent, setEditContent] = useState<any>();
  
  console.log("Task field value", editContent);

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "1em" }}>
      <div>
        { value?.solved && <CheckOutlined /> }
        { !value?.solved && <Button icon={<CheckOutlined />} onClick={() => { onChange({...value, solved: true}); onFinishEdit() } } /> }
      </div>
      <div style={{ flex: 1}}>
        <div style={{ position: "relative", marginTop: "0.5em" }}>
        
        <div style={{ position: "absolute", right: 0, top: 0 }}>
          <Space>
            { edit && <>
              <Button type="primary" icon={<CheckOutlined />} onClick={() => { onChange(editContent); onFinishEdit() } } /><Button danger icon={<IconBanSolid />} onClick={onCancelEdit} />
              </>
            }
            { !value?.solved && !edit && <>
              <Button icon={<EditOutlined onClick={() => { setEditContent(value); onEdit(); } } />} /><Button danger icon={<DeleteOutlined />} onClick={onDelete} />
              </>
            }
            { value?.solved && <>
              <Button danger icon={<DeleteOutlined />} onClick={onDelete} />
              </>
            }
          </Space>
        </div>
        <div><TaskUsernameDate task={value} />:</div>
        {
          edit && 
          <>
          <Row>
          <Input.TextArea
            placeholder=""
            autoSize={{ minRows: 2 }}
            style={{ width: "100%", marginTop: "1em" }}
            value={editContent?.text}
            onChange={evt => setEditContent({...editContent, text: evt.target.value})}
          />
          </Row>
          <Row gutter={6} style={{ marginTop: "1em"}}>
            <Col span={8} style={{ textAlign: "right" }}>
              <Row gutter={6}>
                <Col span={10}>Priorität</Col><Col span={14}><FormItemEnum value={editContent?.priority} label="Priorität" typeData={{ options: [{ label: <><IconAngleDownSolidFull /> Niedrig</>, value: 1 }, { label: <><IconCircleRegularFull /> Mittel</>, value: 3 }, { label: <><IconAngleUpSolidFull /> Hoch</>, value: 5 }] }} onChange={priority => setEditContent({...editContent, priority})} /></Col>
              </Row>
            </Col>
            <Col span={8} style={{ textAlign: "right" }}>
              <Row gutter={6}>
                <Col span={10}>Fällig</Col><Col span={14}><FormItemDate value={editContent?.timestamp} label="Fällig" onChange={timestamp => setEditContent({...editContent, timestamp})} /></Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row gutter={6}>
                <Col span={10} style={{ textAlign: "right" }}>zugewiesen an</Col>
                <Col span={14}>
                  <FormItemUser
                    value={editContent?.assignedUserId} 
                    label="zugewiesen an"
                    onChange={assignedUserId => setEditContent({...editContent, assignedUserId})}  
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          </>
        }
        {
          !edit && <div><TaskDescription task={value} /></div>
        }
        </div>
        <hr/>
      </div>
  </div>)
}

function Tasks({ objectId, objectType, noHeader }: any) {
  const [form] = Form.useForm();
  const [formSolvedTasks] = Form.useForm();
  const { data } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: objectType }, objectId: { c: "EQ", v: objectId }, solved: { c: "EQ", v: false } }), st: JSON.stringify({ id: 'desc' }) }) as any
  const { data: solvedTasks } = useGetTasksQuery({ f: JSON.stringify({ objectType: { c: "EQ", v: objectType }, objectId: { c: "EQ", v: objectId }, solved: { c: "EQ", v: true } }), st: JSON.stringify({ id: 'desc' }) }) as any
  const [createTask] = useCreateTaskWithSaveNotificationMutation();
  const [updateTask] = useUpdateTaskWithSaveNotificationMutation();
  const [deleteTask] = useDeleteTaskWithSaveNotificationMutation();
  const [editTaskIdx, setEditTaskIdx] = useState<number | null>(null);
  
  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
    form.setFieldsValue({ items: [{}, ...(data?.items || [])]})
  }, [form, data])

  useEffect(() => {
    formSolvedTasks.setFieldsValue(solvedTasks)
  }, [formSolvedTasks, solvedTasks])

  const onFinish = useCallback(async (values: any) => {
    const newComment = {
      objectType,
      objectId, 
      solved: false,
      ...values.items[0]
    }
    //console.log("Values", values, newComment);
    createTask(newComment);
  }, [createTask, objectId, objectType]);

  const onUpdateTask = useCallback(async (commentIdx: number) => {
    const values = form.getFieldsValue();
    const newComment = values.items[commentIdx];
    updateTask(newComment);
  }, [form, updateTask])

  const onDeleteTask = useCallback(async (commentIdx: number) => {
    const values = form.getFieldsValue();
    const commentForDeletion = values.items[commentIdx];
    deleteTask(commentForDeletion);
  }, [form, deleteTask])

  return (<div style={{ height: "100%", overflow: "scroll" }}>
    <Form form={form} name="tasks" style={formStyle} onFinish={onFinish}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>
        { !noHeader && <Row><h3>Todos</h3></Row> }
        <Row>
          <Col span={24}>
            { fields[0] && 
              <Form.Item 
                {...fields[0]}
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                name={[fields[0].name, "text"]}
              >
                <Input.TextArea
                  placeholder="Neuen Task einfügen"
                  autoSize={{ minRows: 2 }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            }
          </Col>
        </Row>
        <Row>
          { fields[0] && 
          <>
          <FormItem field={fields[0]} type="date" fieldName="timestamp" label="Fällig" />
          <FormItem field={fields[0]} fieldName="assignedUserId" label="zugewiesen an" type="user" />
          </>
          }
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Space size="small">
            <Button type="primary" htmlType="submit">
              Speichern
            </Button>
          </Space>
        </div>
        {
          fields.filter((_, idx) => idx !== 0).map((field, idx) => <Row>
            <Col span={24}>
            <Form.Item 
                {...field}
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                name={[field.name]}
              >
                <TaskField 
                    edit={editTaskIdx === idx + 1} 
                    onEdit={() => setEditTaskIdx(idx + 1)} 
                    onFinishEdit={() => { onUpdateTask(idx + 1); setEditTaskIdx(null); } } 
                    onCancelEdit={() => setEditTaskIdx(null)}
                    onDelete={() => onDeleteTask(idx + 1) }
                />
              </Form.Item>
            </Col>
          </Row>)
        }
      </>}
    </Form.List>
  </Form>


  <Form form={formSolvedTasks} name="solvedTasks" style={formStyle} onFinish={onFinish}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>
        { !noHeader && <Row><h3>Erledigte Todos</h3></Row> }
        {
          fields.map((field, idx) => <Row>
            <Col span={24}>
            <Form.Item 
                {...field}
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                name={[field.name]}
              >
                <TaskField 
                    edit={editTaskIdx === idx + 1} 
                    onEdit={() => setEditTaskIdx(idx + 1)} 
                    onFinishEdit={() => { onUpdateTask(idx + 1); setEditTaskIdx(null); } } 
                    onCancelEdit={() => setEditTaskIdx(null)}
                    onDelete={() => onDeleteTask(idx + 1) }
                />
              </Form.Item>
            </Col>
          </Row>)
        }
      </>}
    </Form.List>
  </Form>
  </div>
  
  )
}

export default Tasks;